/**
 * @fileoverview POST handler for the "/engagement/report_builder_2/:report_id/:app_group_id/run" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementReportBuilder2ReportIdAppGroupIdRunCacheKeys } from "./constants";
import type { PostEngagementReportBuilder2ReportIdAppGroupIdRunProps } from "./types";

export const postEngagementReportBuilder2ReportIdAppGroupIdRun = reactQueryMutationAdapter(
  engagementReportBuilder2ReportIdAppGroupIdRunCacheKeys,
  (props: PostEngagementReportBuilder2ReportIdAppGroupIdRunProps): Promise<{}> => {
    return fetch(
      `/engagement/report_builder_2/${props.reportId}/${props.appGroupId}/run`,
      "POST",
      props,
      undefined,
      {
        propagateFetchRequestError: false,
      }
    );
  }
);
